var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.value,"items":_vm.categoryItems,"label":"Categoria","dense":"","outlined":"","clearable":"","loading":_vm.loading,"disabled":_vm.disabled},on:{"change":_vm.onCategoryChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }